/** Shallow open channel between the raised slatted decks. */
import * as THREE from 'three';
import { surface } from '../materials';
import type { AssetDefinition } from '../types';

function buildBottom(): THREE.BufferGeometry {
  const geometry = new THREE.BufferGeometry();
  // The fall is physical rather than a dark painted stripe: the latter vanished
  // under the grade and left the channel reading as a seam, not drainage.
  geometry.setAttribute('position', new THREE.Float32BufferAttribute([
    -0.12, 0.018, -1.2, 0.12, 0.018, -1.2, -0.12, 0.006, 1.2, 0.12, 0.006, 1.2,
  ], 3));
  geometry.setIndex([0, 2, 1, 1, 2, 3]);
  geometry.computeVertexNormals();
  return geometry;
}

function build(): THREE.Group {
  const group = new THREE.Group();
  group.name = 'drain-channel';
  const concrete = surface('mineral', 0x69736f);
  const left = new THREE.Mesh(new THREE.BoxGeometry(0.02, 0.09, 2.4), concrete);
  left.name = 'left-channel-wall'; left.position.set(-0.13, 0.045, 0);
  const right = left.clone(); right.name = 'right-channel-wall'; right.position.x = 0.13;
  const bottom = new THREE.Mesh(buildBottom(), concrete); bottom.name = 'sloped-channel-bottom';
  group.add(left, right, bottom);
  return group;
}

export const drainChannelAsset: AssetDefinition = {
  id: 'drain-channel', label: 'Drain channel', description: 'Open 2.4 m concrete sluice with a shallow longitudinal fall.',
  footprint: { width: 0.28, height: 0.09, length: 2.4 }, create: build,
};
